import messages from '../../../../locale/messages';

const validate = values => {

  const errors = {}

  if (!values.benefitsTitle1) {
    errors.benefitsTitle1 = messages.required;
  } else if (values.benefitsTitle1.trim() == "") {
    errors.benefitsTitle1 = messages.required;
  } else if (values.benefitsTitle1 && values.benefitsTitle1.length > 200) {
    errors.benefitsTitle1 = messages.exceedLimit;
  }

  if (!values.benefitsContent1) {
    errors.benefitsContent1 = messages.required;
  } else if (values.benefitsContent1.trim() == "") {
    errors.benefitsContent1 = messages.required;
  } else if (values.benefitsContent1 && values.benefitsContent1.length > 400) {
    errors.benefitsContent1 = messages.exceedLimit;
  }

  if (!values.benefitsTitle2) {
    errors.benefitsTitle2 = messages.required;
  } else if (values.benefitsTitle2.trim() == "") {
    errors.benefitsTitle2 = messages.required;
  }

  if (!values.benefitsContent2) {
    errors.benefitsContent2 = messages.required;
  } else if (values.benefitsContent2.trim() == "") {
    errors.benefitsContent2 = messages.required;
  } else if (values.benefitsContent2 && values.benefitsContent2.length > 400) {
    errors.benefitsContent2 = messages.exceedLimit;
  }

  if (!values.benefitsTitle3) {
    errors.benefitsTitle3 = messages.required;
  } else if (values.benefitsTitle3.trim() == "") {
    errors.benefitsTitle3 = messages.required;
  } else if (values.benefitsTitle3 && values.benefitsTitle3.length > 200) {
    errors.benefitsTitle3 = messages.exceedLimit;
  }

  if (!values.benefitsContent3) {
    errors.benefitsContent3 = messages.required;
  } else if (values.benefitsContent3.trim() == "") {
    errors.benefitsContent3 = messages.required;
  } else if (values.benefitsContent3 && values.benefitsContent3.length > 400) {
    errors.benefitsContent3 = messages.exceedLimit;
  }

  return errors
}

export default validate;